import React from 'react';

const OnlineStatusDot = ({ online }) => (
  <span
    className={`chat-status-dot ${online ? 'chat-status-dot--online' : 'chat-status-dot--offline'}`}
    aria-label={online ? 'Online' : 'Offline'}
  />
);

export default OnlineStatusDot;
